import React, { useState } from 'react';
import '../styles/AuthModal.css';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const AuthModal = ({ onClose }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, register } = useAuth();
  const { translations } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = isLogin
        ? await login(email, password)
        : await register(email, password, name);   // ← name passed here

      if (result.success) {
        onClose();
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <button className="auth-close" onClick={onClose}>×</button>

        <div className="auth-tabs">
          <button className={isLogin ? 'active' : ''} onClick={() => setIsLogin(true)}>
            {translations.auth.signIn}
          </button>
          <button className={!isLogin ? 'active' : ''} onClick={() => setIsLogin(false)}>
            {translations.auth.signUp}
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}

          {/*  NAME  –  only for sign-up  */}
          {!isLogin && (
            <input
              type="text"
              placeholder={translations.auth.fullName}
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={loading}
              minLength={2}
            />
          )}

          <input
            type="email"
            placeholder={translations.auth.email}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />

          <input
            type="password"
            placeholder={translations.auth.password}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            minLength={6}
          />

          <button type="submit" disabled={loading}>
            {loading ? '...' : isLogin ? translations.auth.login : translations.auth.createAccount}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthModal;